export function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export function getBaseUrl(uri: string) {
  const matches = uri.match(/^(http|https):\/\/([a-z]|-|:|[0-9]|\.)+\//)
  if(!matches || matches.length < 1) {
    throw new Error('no uri')
  }
  return matches[0].replace(/\/$/, '')
}

export function openNewWindow(url: string, target: '_blank' | '_self') {
  window.open(url, target)
}

const hasChannelTalk = () => {
  return Boolean(window.ChannelIO)
}

export const showChannelTalk = () => {
  if(hasChannelTalk()) {
    window.ChannelIO('showMessenger')
  }
}
